{"rating":"4.9","reviewCount":"141","fetchedAt":"2026-10-19T22:22:23.425Z","source":"place-details"}